import { FrameRectangle } from '../../../../../common/components/cart-loader/frame-rectangle/FrameRectangle';
import styles from './ProductCardListLoader.module.scss';

export const ProductCardListLoader = ({
  className,
  isWishList,
  forceMobileView = false,
  fromDrawer = false,
}: {
  isWishList?: boolean;
  className?: string;
  forceMobileView?: boolean;
  fromDrawer?: boolean;
}) => (
  <div
    className={`
  ${styles['product-card-list-loader']} 
  ${forceMobileView && styles['product-card-list-loader-mobile-view']}
  ${className}`}
  >
    <FrameRectangle className={styles['product-card-list-loader-section-right-box']} />
    <div className={styles['product-card-list-loader-section-left']}>
      <FrameRectangle className={styles['product-card-list-loader-section-left-box']} />
      <FrameRectangle className={styles['product-card-list-loader-section-left-box']} />
      {!fromDrawer && <FrameRectangle className={styles['product-card-list-loader-section-left-box']} />}

      {isWishList ? (
        <FrameRectangle className={styles['product-card-list-loader-section-left-box-tablet']} />
      ) : (
        <FrameRectangle className={styles['product-card-list-loader-section-left-box-wishlist']} />
      )}
    </div>
  </div>
);
